module.exports = __webpack_public_path__ + "img/passo-02.c104c87c.svg";